import React from 'react';
import PlayArrowRounded from '@material-ui/icons/PlayArrowRounded';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import { guc } from '../../services/Localisation';
import { merge, path, isEmptyString } from '../../utils';
import { h6, bold, rowCenter, centerAbs } from '../../resources/styles';
import { GrowTransition } from '../utils';

export default class VideoCard extends React.Component {

    state = {
        player: false,
    }

    getThumb = () => !isEmptyString(this.props.thumbnail) ? this.props.thumbnail
        : !isEmptyString(this.props.youtubeID) ? `https://img.youtube.com/vi/${this.props.youtubeID}/mqdefault.jpg`
            : null;

    getEmbed = () => `https://www.youtube.com/embed/${this.props.youtubeID}`;

    onPlay = () => path(this.props, 'onPlay', () => this.setState({ player: true }))();

    closePlayer = () => this.setState({ player: false, iframeLoaded: false });

    render = () => <div style={merge(styles.container, this.props.style)}>
        <img src={this.getThumb()} alt='video-thumbnail' style={styles.thumbnail} />
        <div style={styles.content}>
            <div style={styles.play} onClick={this.onPlay}><PlayArrowRounded style={styles.icon} />{guc('play_video','Play Video')}</div>
            <div style={styles.title}>{this.props.title}</div>
            <div style={styles.description}>{this.props.description}</div>
        </div>
        <Dialog maxWidth='md' fullWidth open={this.state.player} TransitionComponent={GrowTransition} onClose={this.closePlayer} PaperProps={{ style: styles.paper }}>
            <iframe style={styles.iframe} src={this.getEmbed()} frameBorder='0' title='video' className='fillSpace' />
            <div style={styles.loader}><CircularProgress /></div>
        </Dialog>
    </div>;

}

const styles = {

    container: { display: 'flex', flexDirection: 'column', minWidth: 340, borderRadius: 6, overflow: 'hidden' },

    thumbnail: { width: 340, height: 172, display: 'block', objectFit: 'cover' },

    content: { flex: 1, position: 'relative', padding: 16, backgroundColor: 'white' },

    play: { ...rowCenter, position: 'absolute', top: 0, transform: 'translateY(-50%)', cursor: 'pointer', backgroundColor: 'black', color: 'white', padding: '2px 8px 2px 2px', borderRadius: 4 },

    icon: { marginRight: 4 },

    title: { ...h6, ...bold, marginTop: 12 },

    description: { marginTop: 12 },

    paper: { minHeight: '60vh', maxHeight: '60vh' },

    iframe: { width: '100%', height: '100%', zIndex: 1 },

    loader: { ...centerAbs, zIndex: 0 }

};